import React, { useEffect, useState } from "react";
import Headar from "../Component/Headar";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../Css/ContactUs.css";
import { Col, Container, Row } from "react-bootstrap";
import MemberShipImg from "../aseets/img/membershipBanner.png";
import axios from "axios";
import Footer from "../Component/Footer";
import ShapeImg from "../aseets/img/curve.png";
import MobileHader from "../Component/MobileHader";
import { InfinitySpin } from "react-loader-spinner";
import { useParams } from "react-router-dom";
import ScanerImg from "../aseets/img/Scanner.png"
import BradCrum from "../Component/BradCrum";

const MemberShip = () => {
  // const { title: plan } = useParams();
  const plan = "platinum";
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate a delay of 2 seconds (adjust as needed)
    const delay = 1000;
    setTimeout(() => {
      setIsLoading(false);
    }, delay);
  }, []);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/create/contact-form`,
        values
      );
      alert("Form submitted successfully!");
      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object({
    FirstName: Yup.string()
      .min(3, "Must be at least 3 characters")
      .required("First Name is required"),
    LastName: Yup.string()
      .min(3, "Must be at least 3 characters")
      .required("Last Name is required"),
    // Phone: Yup.string()
    //   .matches(/^[0-9]+$/, "Phone must be numeric")
    //   .min(10, "Must be at least 10 digits")
    //   .required("Phone is required"),
    Email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    DOB: Yup.date().required("Date of Birth is required"),
    Gender: Yup.string().required("Gender is required"),
    // Address: Yup.string().required("Address is required"),
    City: Yup.string().required("City is required"),
    // PinCode: Yup.string()
    //   .matches(/^[0-9]+$/, "Pincode must be numeric")
    //   .required("Pincode is required"),
    Country: Yup.string().required("Country is required"),
    FatherName: Yup.string().required("Father Name is required"),
    MotherName: Yup.string().required("Mother Name is required"),
    Siblings: Yup.number()
     
      // .min(0, "Must be 0 or more")
      .required("Number of Siblings is required"),
    Education: Yup.string().required("Education is required"),
    Profession: Yup.string().required("Profession is required"),
    CompanyName: Yup.string().required("Company Name/Details are required"),
    Height: Yup.string().required("Height is required"),
    foodPrefrence: Yup.string().required("foodPrefrence is required"),
    Religion: Yup.string().required("Religion is required"),
    Status: Yup.string().required("Relationship Status is required"),
    // Message: Yup.string().required("Message is required"),
    // HereFrom: Yup.string().required("This field is required"),
  });
  const [bannerImages, setBannerImages] = useState({});
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/auth/list/inner-banners`
        );
        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 1
        ) {
          setBannerImages(response.data, "===>");
        }
      } catch (error) {
        console.error("Error fetching banner images:", error);
      }
    };

    fetchBannerImages();
  }, []);
  return (
    <React.Fragment>
      {/* {isLoading ? (
        // Loader component while loading
        <div className="loader-container">
          <InfinitySpin
            color="#000"
            height={50}
            width={50}
            timeout={0}
          />
        </div>
      ) : ( */}
        <div className="meberFormMainDiv">
          {/* <Headar />
          <MobileHader />
          <BradCrum
            Title={bannerImages[1]?.Title}
            ShapeImg={ShapeImg}
            BradCrumImg={`${process.env.REACT_APP_API_URL}/${bannerImages[1]?.bannerImage}`}
            color="#fff"
          /> */}
          {/* <BannerSection /> */}
          <Container>
            <div className="contactUsDiv">
              <div className="contactUsMainDiv">
                <div className="missonTite membershipMissonTitle">
                  Join the Platinum Family Today!
                </div>
                <div className="contactUsDescription">
                  Become part of a vibrant community dedicated to meaningful
                  connections. Our personalized approach and expert guidance are
                  here to support you in finding your perfect match. Your
                  journey to love starts with us!
                </div>
              </div>
            </div>
</Container>
            <Formik
              initialValues={{
                FirstName: "",
                LastName: "",
                Phone: "",
                Email: "",
                DOB: "",
                Gender: "",
                Address: "",
                City: "",
                // PinCode: "",
                Country: "",
                FatherName: "",
                MotherName: "",
                Siblings: "",
                Education: "",
                Profession: "",
                CompanyName: "",
                Height: "",
                foodPrefrence: "",
                Religion: "",
                Status: "",
                Message: "",
                HereFrom: "",
                Plan: plan,
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
          <Container>

                  <Row>
                    <Col className="mb-3" lg={6} md={6}>
                      <div className="formLable">
                        <label>
                          First Name <span>*</span>
                        </label>
                      </div>
                      <Field
                        className="inputFild  memberInput"
                        type="text"
                        name="FirstName"
                      />
                      <ErrorMessage
                        name="FirstName"
                        component="div"
                        className="error"
                      />
                    </Col>
                    <Col className="mb-3" lg={6} md={6}>
                      <div className="formLable">
                        <label>
                          Last Name <span>*</span>
                        </label>
                      </div>
                      <Field
                        className="inputFild   memberInput"
                        type="text"
                        name="LastName"
                      />
                      <ErrorMessage
                        name="LastName"
                        component="div"
                        className="error"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-3" lg={6} md={6}>
                      <div className="formLable">
                        <label>
                          Phone 
                        </label>
                      </div>
                      <Field className="inputFild memberInput  " type="text" name="Phone" />
                      {/* <ErrorMessage
                        name="Phone"
                        component="div"
                        className="error"
                      /> */}
                    </Col>
                    <Col className="mb-3" lg={6} md={6}>
                      <div className="formLable">
                        <label>
                          Email <span>*</span>
                        </label>
                      </div>
                      <Field className="inputFild memberInput " type="email" name="Email" />
                      <ErrorMessage
                        name="Email"
                        component="div"
                        className="error"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-3" lg={6} md={6}>
                      <div className="formLable">
                        <label>
                          Date of Birth <span>*</span>
                        </label>
                      </div>
                      <Field className="inputFild memberInput  " type="date" name="DOB" />
                      <ErrorMessage
                        name="DOB"
                        component="div"
                        className="error"
                      />
                    </Col>
                    <Col className="mb-3" lg={6} md={6}>
                      <div className="formLable">
                        <label>
                          Gender <span>*</span>
                        </label>
                      </div>
                      <div className="radioMainDiv">
                        <div className="radioDiv">
                          <Field type="radio" name="Gender" value="Male" /> Male
                        </div>
                        <div className="radioDiv">
                          <Field type="radio" name="Gender" value="Female" />{" "}
                          Female
                        </div>
                      </div>

                      <ErrorMessage
                        name="Gender"
                        component="div"
                        className="error"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-3" lg={12} md={12}>
                      <div className="formLable">
                        <label>
                          Address 
                        </label>
                      </div>
                      <Field
                        rows="4"
                        as="textarea"
                        className="inputFild  memberInput"
                        type="text"
                        name="Address"
                      />
                      {/* <ErrorMessage
                        name="Address"
                        component="div"
                        className="error"
                      /> */}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Your City <span>*</span>
                        </label>
                      </div>
                      <Field className="inputFild memberInput " type="text" name="City" />
                      <ErrorMessage
                        name="City"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="foodPrefrence">
                          Food Preference <span>*</span>
                        </label>
                      </div>
                      <Field
                        as="select" /* Using 'as' to render a select element */
                        className="inputFild  memberInput"
                        name="foodPrefrence"
                      >
                        <option value="" disabled>
                          Select Food Preference
                        </option>
                        <option value="Veg">Veg</option>
                        <option value="Non-Veg">Non-Veg</option>
                      </Field>
                      <ErrorMessage
                        name="foodPrefrence"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Country <span>*</span>
                        </label>
                      </div>
                      <Field className="inputFild  memberInput" type="text" name="Country" />
                      <ErrorMessage
                        name="Country"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Father Name <span>*</span>
                        </label>
                      </div>
                      <Field
                        className="inputFild  memberInput"
                        type="text"
                        name="FatherName"
                      />
                      <ErrorMessage
                        name="FatherName"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Mother Name <span>*</span>
                        </label>
                      </div>
                      <Field
                        className="inputFild  memberInput"
                        type="text"
                        name="MotherName"
                      />
                      <ErrorMessage
                        name="MotherName"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Number Of Siblings <span>*</span>
                        </label>
                      </div>
                      <Field
                        className="inputFild  memberInput"
                        type="number"
                        name="Siblings"
                      />
                      <ErrorMessage
                        name="Siblings"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Education <span>*</span>
                        </label>
                      </div>
                      <Field
                        className="inputFild  memberInput"
                        type="text"
                        name="Education"
                      />
                      <ErrorMessage
                        name="Education"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Profession <span>*</span>
                        </label>
                      </div>
                      <Field
                        className="inputFild  memberInput"
                        type="text"
                        name="Profession"
                      />
                      <ErrorMessage
                        name="Profession"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Company Name <span>*</span>
                        </label>
                      </div>
                      <Field
                        className="inputFild  memberInput"
                        type="text"
                        name="CompanyName"
                      />
                      <ErrorMessage
                        name="CompanyName"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Height <span>*</span>
                        </label>
                      </div>
                      <Field className="inputFild  memberInput" type="text" name="Height" />
                      <ErrorMessage
                        name="Height"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Religion <span>*</span>
                        </label>
                      </div>
                      <Field
                        className="inputFild  memberInput"
                        type="text"
                        name="Religion"
                      />
                      <ErrorMessage
                        name="Religion"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                    <Col className="mb-3" lg={4} md={4}>
                      <div className="formLable">
                        <label htmlFor="name">
                          Relationship Status <span>*</span>
                        </label>
                      </div>
                      <Field className="inputFild  memberInput" type="text" name="Status" />
                      <ErrorMessage
                        name="Status"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-3" lg={6} md={6}>
                      <div className="formLable">
                        <label>
                          Additional information 
                        </label>
                      </div>
                      <Field
                        as="textarea"
                        className="inputFild  memberInput"
                        type="text"
                        name="Message"
                        rows="4"
                      />
                      {/* <ErrorMessage
                        name="Message"
                        component="div"
                        className="error"
                      /> */}
                    </Col>
                    <Col className="mb-3" lg={6} md={6}>
                      <div className="formLable">
                        <label>
                          Where did you hear about us? 
                        </label>
                      </div>
                      <Field
                        className="inputFild  memberInput"
                        type="text"
                        name="HereFrom"
                      />
                      {/* <ErrorMessage
                        name="HereFrom"
                        component="div"
                        className="error"
                      /> */}
                    </Col>
                    </Row>
                    </Container>
                    <div className="suceesStoryDiv">
                      <Container>
                      <div className="scannerMainDiv">
                        <div>
                    <div className="scanerTitle">
                    A one-time registration fee applies, and a success fee is due upon a successful match
                    </div>
                    <div className="scannerSubTitle">
                    Scan this code in your bank’s app to pay 
                    </div>
                    </div>
                    </div>
                    <div>
                      <div className="sanerrDiv">
                     <img className="scannerImg" src={ScanerImg} alt="img"/>

                  
                      </div>
                      <div className="sanerrDiv">
                      <button
                    className="submitBtn memberSubmit"
                    type="submit"
                    // disabled={isSubmitting}
                    // onClick={handleSubmit}
                  >
                    Submit
                  </button>
                  </div>
                    </div>
                    </Container>
                  </div>
                  {/* <button
                    className="submitBtn"
                    type="submit"
                    // disabled={isSubmitting}
                    // onClick={handleSubmit}
                  >
                    Submit
                  </button> */}
                </Form>
              )}
            </Formik>
          {/* <Footer /> */}
        </div>
      {/* )} */}
    </React.Fragment>
  );
};

export default MemberShip;
